import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useDispatch } from 'react-redux';
import OSelect from '../../../Components/OElements/OSelect';
import { getFileType } from '../../../helpers/file_manager/backend_helper';
import { uploadFile } from '../../../slices/thunks';


const UploadOneFileForm = ({
	folderId,
	fileTypeId,
	handleUploadLocalFile,
	isOpen,
	handleToggleModal,
	handleNewDocumentId,
	activeTab,
	toggleTab
}) => {
	const dispatch = useDispatch();

	const [fileType, setFileType] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			file_type_id: '',
			document: ''
		},
		validationSchema: Yup.object({
			file_type_id: Yup.string().required('Campo requerido'),
			document: Yup.mixed()
				.test('documentUploaded', 'El archivo es requerido', value => {
					return value ? true : false;
				})
				.test('documentFormat', 'Solo puede subir extensiones .pdf', value => {
					if (value) {
						const supportedFormats = ['pdf'];
						return supportedFormats.includes(value.name.split('.').pop());
					}
					return true;
				})
				.test('documentSize', 'El archivo no puede superar el tamaño máximo de 10MB', value => {
					if (value) {
						return value.size <= 10485760;
					}
					return true;
				})
		}),
		onSubmit: async (values) => {
			if (folderId) {
				setIsLoading(true);
				const formData = new FormData();
				formData.append('file', values.document);
				try {
					const responseUploadFile = await dispatch(uploadFile({
						file_path: '',
						folder_id: folderId,
						file_type_id: values.file_type_id,
						formData: formData
					})).unwrap();

					if (handleNewDocumentId) {
						handleNewDocumentId(responseUploadFile._id);
					}
					handleToggleModal();
					setIsLoading(false);
				} catch (err) {
					setIsLoading(false);
					console.error('Error al subir archivo:', err);
				}
			} else {
				handleUploadLocalFile(values.document, fileType?.name)
				handleToggleModal();
			}
		},
	});

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId={'1'}>
						<Row className='g-3'>
							<Col lg={12}>
								<Label for="document">
									Archivo
								</Label>
								<Input
									id="document"
									name="document"
									type="file"
									onChange={(e) => {
										const file = e.currentTarget.files[0];
										validation.setFieldValue("document", file || '');
									}}
									onBlur={validation.handleBlur}
									invalid={
										validation.touched.document &&
											validation.errors.document ?
											true : false
									}
								/>
								{validation.errors.document && (
									<div className="invalid-feedback d-block">
										{validation.errors.document}
									</div>
								)}
							</Col>
							<Col lg={12}>
								<OSelect
									key={fileTypeId || ''}
									label='Tipo de documento'
									id='file_type_id'
									name='file_type_id'
									value={fileTypeId || ''}
									requestApi={() => getFileType()}
									onSelect={(item) => setFileType(item)}
									disabled={(
										fileTypeId
											? true : false
									)}
									validation={validation}
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='button'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isLoading
						}
						onClick={() => {
							validation.handleSubmit();
						}}
					>
						{
							isLoading
								? (
									<i className='label-icon'>
										<Spinner size='sm' />
									</i>
								)
								: <i className='ri-save-3-line label-icon'></i>
						}
						Subir
					</button>
				</div>
			</div>
		</Form>
	);
};

export default UploadOneFileForm;
